import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/role/list';

const PageCreateRole: React.FC = () => {
  const CreateRole = Loadable({
    loader: () => import('./page'),
    loading: LoadableLoading,
  });

  return <CreateRole />;
};

export default PageCreateRole;
